/**
 * Asynchronously loads the component for CampusBulkUpload
 */

import { lazyLoad } from "utils/loadable";

export const CampusBulkUpload = lazyLoad(
  () => import("./index"),
  (module) => module.CampusBulkUpload
);
